const connection = { 'on': function(){}, 'emit': function(){} };

module.exports = {
	connection
}
